import { ReactElement } from 'react';

import { BannerGiftPng, StarsBackgroundPng } from '@cashier/cashier-assets';

import { useAmountValueContext } from '../../../../contexts';
import { useBonusBanner, useBonusConfiguration } from '../../hooks';

import styles from './styles.module.scss';

export const BonusBanner = (): ReactElement | null => {
  const { getConfigurationByAmount } = useBonusConfiguration();
  const { generateCTA, generateTitle } = useBonusBanner();

  const { value: amount } = useAmountValueContext();

  const bonusConfiguration = getConfigurationByAmount(amount);

  if (
    !bonusConfiguration?.isCalculatorActive ||
    !bonusConfiguration?.displayCalculator
  ) {
    return null;
  }

  return (
    <div className={styles.wrapper} data-test="bonus-calculator-container">
      <img
        className={styles.backgroundImage}
        src={StarsBackgroundPng}
        alt="starts background"
      />
      <div className={styles.icon} data-test="bonus-calculator-icon">
        <img className={styles.giftImage} src={BannerGiftPng} alt="gift" />
      </div>
      <div>
        <div className={styles.title} data-test="bonus-calculator-title">
          {generateTitle(amount, bonusConfiguration.interval)}
        </div>
        <div className={styles.text} data-test="bonus-calculator-description">
          {generateCTA(amount, bonusConfiguration.interval)}
        </div>
      </div>
    </div>
  );
};
